import { Seo, FaqSchema } from "@/components/site/Seo";
import { PageHero } from "@/components/sections/PageHero";
import { LeadForm } from "@/components/sections/LeadForm";
import { Faq } from "@/components/sections/Faq";

export default function ContactPage() {
  return (
    <main data-testid="contact-page">
      <Seo path="/contact" title="Contact Solar Energy Doc | Free Solar Quote in Texas"
        description="Request a free quote from Solar Energy Doc LLC. Solar installation, batteries, repair, maintenance, detach & reset and electrical services across Texas." />
      <FaqSchema />
      <PageHero eyebrow="Contact" testId="contact-page-hero" lines={["Let's talk about", "your energy."]}
        sub="Request a free quote, schedule service or ask a question. Call us directly or send the form below and our team will follow up." />
      <LeadForm />
      <Faq />
    </main>
  );
}
